enum AmbienteEnvioNFe {
    Producao = 1,
    Homologacao = 2,
}

export default AmbienteEnvioNFe;
